import { render, staticRenderFns } from "./descriptionEditor.vue?vue&type=template&id=6ef60654&scoped=true&"
import script from "./descriptionEditor.vue?vue&type=script&lang=js&"
export * from "./descriptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./descriptionEditor.vue?vue&type=style&index=0&id=6ef60654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef60654",
  null
  
)

export default component.exports